
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"33.929","height":"33.929","viewBox":"0 0 33.929 33.929"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#090A0A","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/eye"}},[_c('path',{attrs:{"d":"M22.025 16.964a5.061 5.061 0 11-5.061-5.061 5.056 5.056 0 015.061 5.061z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M16.964 28.659c4.99 0 9.641-2.94 12.879-8.03a7.529 7.529 0 000-7.337c-3.238-5.093-7.889-8.033-12.879-8.033s-9.641 2.94-12.879 8.03a7.529 7.529 0 000 7.337c3.238 5.089 7.889 8.033 12.879 8.033z"}})])])
          )
        }
      }
    